import { StopDto } from '@/features/trips/StopDto';

export enum BookingNoShowType {
    None = 0,
    NoTravellers = 1,
    TooFewTravellers = 2
}

export interface BookingNoShowPage {
    page: number;
    size?: number;
}

export interface BookingNoShowFilters {
    dateFrom?: string;
    dateTo?: string;
    noShowType?: BookingNoShowType;
    tripId?: string;
    operatingDay?: string;
}

export interface TripStopDto {
    stopName: string;
    sequenceOrder: number;
    stop: StopDto;
    passingTime: Date;
}

export interface BookingNoShowResponseDto {
    id: number;
    tripId: string;
    operatingDay: string;
    tripStop: TripStopDto;
    bookingNoShowType: BookingNoShowType;
    bookingCount: number;
    departure: string;
    destination: string;
}

export interface BookingData {
    tripId: string;
    tripStop: TripStopDto;
    bookingCount: number;
    operatingDay: string;
    calendarDay: string;
}

export interface DeleteBookingNoShowRequest {
    tripId: string;
    operatingDay: string;
    tripStop: TripStopDto;
}
